import { DropdownItem } from '../components/forms/DropdownInput';
import { PlaceholderType, PlaceholderValues } from '../models/PlaceholderValues'

export const getPlaceholders = (placeholders : PlaceholderValues[]): string[] => {
    let conditionKeys : string[] = [];
    
    placeholders.forEach((question: PlaceholderValues) => {
        conditionKeys?.push(question.Key);
    });

    return conditionKeys;
};

export const getPlaceholdersDropDown = (placeholders : PlaceholderValues[]): DropdownItem[] => {
    let conditionKeysArray: DropdownItem[] = [];

    placeholders.forEach((question: PlaceholderValues) => {
        conditionKeysArray = conditionKeysArray || [];
        conditionKeysArray.push({
            key: question.Key,
            value: question.Key,
            description: null
        });
    });

    return conditionKeysArray;
};

export const getPlaceholderValuesDropDown = (placeholders : PlaceholderValues[]): Record<string, DropdownItem[]> => {
    let conditionValuesRecord: Record<string, DropdownItem[]> = {};

    placeholders.forEach((question: PlaceholderValues) => {

        if (question.Type === PlaceholderType.list) {

            const key = question.Key
            const answers = Array.isArray(question.Options) ? question.Options : [];

            if (answers && answers.length > 0) {

                const answerDropdowns: DropdownItem[] = answers.map((answer: string) => ({
                    key: answer,
                    value: answer,
                    description: null
                }));

                if(conditionValuesRecord) {
                    conditionValuesRecord[key] = answerDropdowns;
                }
            }
        } else if (question.Type === PlaceholderType.bool) {
            const key = question.Key
            const answerDropdowns: DropdownItem[] = [
                { key: 'true', value: 'true', description: null },
                { key: 'false', value: 'false', description: null },
            ];

            if(conditionValuesRecord) {
                conditionValuesRecord[key] = answerDropdowns;
            }
        }
        
    });

    return conditionValuesRecord;
};